export default {
    'memberBenefit.title': '会員特典',
} as Record<string, string>;